import { get, post, put, del } from '../request'

export const getEquipments = (filters, pagination) =>
  get('api/equipments', {
    filters,
    pagination,
    populate: [
      'inventories',
      'inventories.target_project',
      'inventories.target_stockroom',
      'current_project',
      'current_stockroom',
      'create_user',
    ],
    sort: 'id:desc', // not working in strapi 4.8.2
  })

export const getGroupedEquipments = (filters, pagination) =>
  get('api/equipments/findWithGroups', { filters, pagination })

export const createEquipment = (params) => post('api/equipments', params)
export const fetchEquipment = (id) => get(`api/equipments/${id}`, { populate: ['images'] })
export const updateEquipment = (id, params) => put(`api/equipments/${id}`, params)
export const delEquipment = (id) => del(`api/equipments/${id}`, {})
